{
  "plus": {
    "profile": {
      "cancel": "",
      "validate": "",
      "next": "",
      "enable": "",
      "disable": "",
      "twoFactorAuth": {
        "sms": "",
        "confirmationModalSms": ""
      }
    }
  },
  "actions": {
    "enable": "Enable"
  },
  "mmbRefundForm": {
    "links": {
      "recloceticket": {
        "link": {
          "url": "/en/1859614-1859614"
        },
        "text": "What is my booking reference or my e-ticket number?"
      },
      "refund": {
        "link": {
          "url": "/en/2664430-2664430"
        },
        "text": "What is the status of my refund request?"
      }
    },
    "submitText": "Find booking",
    "submitAria": "Search for booking",
    "recLocNotFoundError": "We couldn't find your booking. Please ensure that the family name and the booking reference number are correct, and try again.",
    "recLocAlreadyCancelledError": "This booking has already been cancelled, but we haven't received a refund request yet. Please complete the refund form to request your refund.",
    "recLocTourOperatorError": "This booking was made through a travel agency. Please contact them directly to cancel and request a refund."
  }
}
